/**
 * 关于项目的一些配置信息
 */

//是否为开发模式
const isDev = process.env.NODE_ENV === "development";

// 后台请求地址
const backstageUrl = process.env.BASE_URI;

// CDR 接口请求地址
const cdrRequestUrl = process.env.CDR_URI;

const cdrAnllysisUrl = process.env.CDR_ANALYSIS_URI;

// 微信公众号AppID
const appId = process.env.BASE_APPID;

// 微信公众号AppSecret
const appSecret = process.env.BASE_APPSECRET;

// 用户中心地址
const ucWebPath = process.env.UC_WEB_PATH;

// 公共登录js引用
const xtLoginJsPath = process.env.XT_LOGIN_JS_PATH;
// 图片服务器显示地址
const fileServerUrl = process.env.FILE_SERVER_URL;

// userCenter后台请求地址
const ucBackstageUrl = process.env.UC_BASE_URI;
// 企业中心地址
const ccWebPath = process.env.CC_WEB_PATH;
// 前段地址
const prewebUrl = process.env.PRE_WEB_URL;

//websocket 地址
const websocketPath = process.env.WEBSOCKET_PATH;

export {websocketPath, isDev, backstageUrl, appId, ucWebPath, xtLoginJsPath, fileServerUrl, appSecret, cdrRequestUrl,ucBackstageUrl, cdrAnllysisUrl,ccWebPath,prewebUrl};



// WEBPACK FOOTER //
// ./src/config/project-config.js